import { useLayoutEffect } from "react";
import {Layout} from "../../components/common/Layout"
import { MedicsTable } from "../../components/medics/MedicsTable";

export const MedicsPage = () => {

    const title = "Медицинские работники";
    useLayoutEffect(() => {
        document.body.style.backgroundColor = "white"
        document.body.style.backgroundImage = "";
   });
    return (
        <Layout title={title}>
            <MedicsTable/>
        </Layout>
    )
}